import { render } from "./memberPerformanceModal3.vue?vue&type=template&id=c20da6a8&scoped=true&ts=true"
import script from "./memberPerformanceModal3.vue?vue&type=script&lang=ts"
export * from "./memberPerformanceModal3.vue?vue&type=script&lang=ts"

import "./memberPerformanceModal3.vue?vue&type=style&index=0&id=c20da6a8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c20da6a8"]])

export default __exports__